export default __webpack_public_path__ + "static/media/waxing-crescent.ea0319ef.svg";